import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Flex, Spinner } from '../../components';
import { loadStripe } from '@stripe/stripe-js';


import { FAQ, Features, Footer, Header, Navbar, Sitelist } from './sections';

const Release = ({ login }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [licenseData, setLicenseData] = useState(null);
  const [releaseData, setReleaseData] = useState(null);
  const [buttonText, setButtonText] = useState("Sold Out");

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let password = params.get('password');

  const joinWaitlist = () => {
    setIsLoading(true);
    axios
      .put('/api/release/join-waitlist')
      .then(async (res) => {
        setIsLoading(false);
        alert('Joined Waitlist, Monitor your discord\'s account associated email');
      })
      .catch(err => {
        console.error(err);
      });
  }

  const purchase = () => {
    setIsLoading(true);
    axios
      .get('/api/release/purchase?password=' + password)
      .then(async (res) => {
        if (res.data.inStock) {
          const stripe = await loadStripe('pk_live_51IOBLMK44zZnxyP7Q2gS4uloyQ70M25h666dLfP0pvy5LbAtSdU7F0f7mZCb24mPaYePlefAcX3zGtLf6Q0mGE6A00BQO7ya7A');
          stripe.redirectToCheckout({ sessionId: res.data.session.id });
        } else {
          setButtonText("Sold Out, Join Waitlist");
          setIsLoading(false);
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  const renderHeader = () => {

    if (password) {

      if (!licenseData.hasLicense) {

        if (releaseData) {

          if (releaseData.stock_amount > 0) {
            return (
              <Header subText={releaseData.Type.label} buttonText={buttonText} purchase={purchase}></Header>
            )
          } else {
            return (
              <Header subText={releaseData.Type.label} buttonText={buttonText} joinWaitlist={joinWaitlist}></Header>
            )
          }

        } else {
          return (
            <Header subText="Invalid password" buttonText={buttonText} joinWaitlist={joinWaitlist}></Header>
          )
        }

      } else {
        return (
          <Header subText="You already own a license" buttonText={buttonText}></Header>
        )

      }

    } else {
      return (
        <Header subText="No release specified" buttonText={buttonText} joinWaitlist={joinWaitlist}></Header>
      )
    }

  }

  useEffect(() => {

    axios
      .get('/api/dashboard/user/me')
      .then(res => {
        setLicenseData(res.data.licenseData);

        if (password && !res.data.licenseData.hasLicense) {
          axios
            .get('/api/release/get-release-data?password=' + password)
            .then(res => {
              if (res.data != null) {
                setReleaseData(res.data);
                if (res.data.stock_amount > 0) {
                  setButtonText("Purchase");
                }
              } else {
                setButtonText("Join Waitlist");
              }
              setIsLoading(false);
            })
            .catch(err => {
              console.error(err);
            });
        } else {
          setIsLoading(false);
        }

      })
      .catch(err => {
        login();
      });

  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  return (
    <>
      <Navbar />
      <Flex h="150px" />
      {renderHeader()}
      <Flex h="220px" />
      <Features />
      <Flex h="220px" />
      <Sitelist />
      <Flex h="220px" />
      <FAQ />
      <Flex h="220px" />
      <Footer />
    </>
  );

};

export default Release;
